import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoutComponent } from './components/logout/logout.component';
import { MaterialsModule } from './modules/materials/materials.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FilterFormsCollectionPipe } from './pipes/filter-form-collection.pipe';
import { ImageCropperModule } from 'ngx-image-cropper';
import { TagInputModule } from 'ngx-chips';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';



import {
    AccessibilityDirective,
    LoadingDirective,
    TogglePasswordDirective,
    NgSelectAccessibilityDirective,
    RoleDirective,
    ThemeDirective,
    DefaultImageDirective,
    LoadingComponentDirective,
    RequiresFormDirective,
    CharCounterDirective,
    
} from './directives';
import { FileValueAccessorDirective } from './directives/file-value-accesor.directive';
import { ValidCtrlDirective } from './directives/valid-ctrl.directive';
import { httpInterceptorProviders } from './interceptors/interceptors';
import { FilterCollectionPipe } from './pipes/filter-collection.pipe';
import { HeaderComponent } from './components/header/header.component';
import { MapComponent } from './components/map/map.component';
import { ImageComponent } from './components/image/image.component';
import { PdfPreviewComponent } from './components/pdf-preview/pdf-preview.component';
import { ImageCarouselComponent } from './components/image-carousel/image-carousel.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { NgbDatepickerI18n, NgbDatepickerModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { GeocodeResultsModalComponent } from './components/geocode-results-modal/geocode-results-modal.component';
import { RouterModule } from '@angular/router';
import { AddressComponent } from './components/address/address.component';
import { EventComponent } from './components/event/event.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { DatepickerESI18n } from './providers/datepicker-i18n-provider';
import { LoaderComponent } from './components/loader/loader.component';
import { NewAddressComponent } from './components/new-address/new-address.component';
import { NewMapComponent } from './components/new-map/new-map.component';
import { SharedButtonsComponent } from './components/shared-buttons/shared-buttons.component';
import { UbicationComponentComponent } from './components/ubication-component/ubication-component.component';
import { BasicInfoComponentComponent } from './components/basic-info-component/basic-info-component.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { KeeniconComponent } from './keenicon/keenicon.component';
import { UpdateContactInfoComponent } from './components/update-contact-info/update-contact-info.component';
import { UpdateAboutComponent } from './components/update-about/update-about.component';
import { SitemapComponent } from './components/accessibility/components/sitemap/sitemap.component';
import { LenguajeSenasVideoDirective } from './directives/lenguaje-senas-video.directive';
import { SkipLinkDirectiveDirective } from './directives/skip-link-directive.directive';

const components = [LogoutComponent, HeaderComponent, MapComponent, ImageComponent, PdfPreviewComponent, ImageCarouselComponent, GeocodeResultsModalComponent, AddressComponent, EventComponent, CalendarComponent, LoaderComponent, NewAddressComponent, NewMapComponent, SharedButtonsComponent, UbicationComponentComponent, BasicInfoComponentComponent, BreadcrumbComponent, KeeniconComponent];
const directives = [
    LoadingDirective,
    LoadingComponentDirective,
    TogglePasswordDirective,
    ValidCtrlDirective,
    AccessibilityDirective,
    NgSelectAccessibilityDirective,
    RoleDirective,
    ThemeDirective,
    DefaultImageDirective,
    RequiresFormDirective,
    CharCounterDirective,
    FileValueAccessorDirective,
    LenguajeSenasVideoDirective,
    SkipLinkDirectiveDirective
];
const pipes = [FilterCollectionPipe, FilterFormsCollectionPipe, SafeUrlPipe];
const modules = [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, MaterialsModule, NgSelectModule, ImageCropperModule, TagInputModule, NgbRatingModule, NgbDatepickerModule, ShareButtonsModule,ShareIconsModule];

@NgModule({
    declarations: [...components, ...directives, ...pipes, NewMapComponent, SharedButtonsComponent, BreadcrumbComponent, KeeniconComponent, UpdateContactInfoComponent, UpdateAboutComponent, SitemapComponent],
    imports: [...modules],
    exports: [...components, ...directives, ...modules, ...pipes],
    providers: [httpInterceptorProviders, { provide: NgbDatepickerI18n, useClass: DatepickerESI18n }],
})
export class SharedModule {}
